function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { compose, setDisplayName, mapProps } from 'recompose';
import classnames from 'classnames';

var addLunaClass = function addLunaClass(_ref) {
  var _classnames;

  var className = _ref.className,
      fixed = _ref.fixed,
      size = _ref.size,
      fillCurrent = _ref.fillCurrent,
      strokeCurrent = _ref.strokeCurrent,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "fixed", "size", "fillCurrent", "strokeCurrent"]);

  return Object.assign({}, props, {
    className: classnames(className, 'ln-c-icon', (_classnames = {
      'ln-c-icon--fixed': fixed
    }, _classnames["ln-c-icon--" + size] = size, _classnames['ln-c-icon--fill-current'] = fillCurrent, _classnames['ln-c-icon--stroke-current'] = strokeCurrent, _classnames))
  });
};

export { addLunaClass };
export default (
/* istanbul ignore next */
function (Component) {
  return (
    /* istanbul ignore next */
    compose(setDisplayName(Component.displayName || Component.name || 'Icon'), mapProps(addLunaClass))(Component)
  );
});


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/icons/dist/hoc/index.js
// module id = 4
// module chunks = 0